import { render, staticRenderFns } from "./AtendimentoContratoList.vue?vue&type=template&id=fc47f10c&scoped=true"
import script from "./AtendimentoContratoList.vue?vue&type=script&lang=js"
export * from "./AtendimentoContratoList.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoContratoList.vue?vue&type=style&index=0&id=fc47f10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc47f10c",
  null
  
)

export default component.exports